import React from 'react'
import { SummaryLine } from './summary'
import { BoxBody } from '../ui/box'
import Milliseconds from '../helper/milliseconds'
import Percent from '../helper/percent'
import { TraceDetailsTitle } from './tracedetails/TraceDetailsTitle'
import { Col, Row } from '../ui/grid'

interface Props {
    line: SummaryLine
    sectionBelowTitle?: React.ReactNode
    showExclusiveWallTime?: boolean
    showTitle?: boolean
}

export class SummaryLineDetails extends React.PureComponent<Props> {
    public render() {
        const { line, sectionBelowTitle, showExclusiveWallTime = true, showTitle = true } = this.props
        const columnWidth = showExclusiveWallTime ? 4 : 6

        return (
            <>
                {showTitle ? (
                    <TraceDetailsTitle category={line.category} isRoot={false} name={line.name ? line.name : 'No Summary'} />
                ) : null}
                {sectionBelowTitle}
                <BoxBody>
                    <div className="tw-font-size-16 tw-mb-8">
                        <Row>
                            <Col width={columnWidth}>
                                <small>Call Count</small>
                                <br />
                                {line.callCount}
                            </Col>
                            <Col width={columnWidth}>
                                <small>Total Duration</small>
                                <br />
                                <Milliseconds value={line.wallTime} />
                                &nbsp; (<Percent value={line.wallTimePercentage} />)
                            </Col>
                            {showExclusiveWallTime ? (
                                <Col width={4}>
                                    <small>Self Duration</small>
                                    <br />
                                    {line.exclusiveWallTime === 0 ? '-' : <Milliseconds value={line.exclusiveWallTime} />}
                                    {line.exclusiveWallTime === 0 ? (
                                        ''
                                    ) : (
                                        <>
                                            &nbsp; (<Percent value={line.exclusiveWallTimePercentage} />)
                                        </>
                                    )}
                                </Col>
                            ) : null}
                        </Row>
                    </div>
                </BoxBody>
            </>
        )
    }
}
